import queryString from 'query-string';
import dayjs from 'dayjs';
import { BoatPackage } from 'swagger/models';

export const apiHourNameMap = {
  2: 'two_hour_price_cents',
  3: 'three_hour_price_cents',
  4: 'half_day_cents',
  6: 'six_hour_price_cents',
  8: 'all_day_cents',
};

export const apiHourToTemporaryMap = {
  two_hour_price_cents: 'boat_two_hour_price_cents',
  three_hour_price_cents: 'boat_three_hour_price_cents',
  half_day_cents: 'boat_half_day_price_cents',
  six_hour_price_cents: 'boat_six_hour_price_cents',
  all_day_cents: 'boat_all_day_price_cents',
};

export const apiParamsHourNameMapReverse = {
  two_hours: 2,
  three_hours: 3,
  half_day: 4,
  six_hours: 6,
  full_day: 8,
  all_day: 8,
  multi_day: -1,
};

export const apiParamsHourNameMap = {
  2: 'two_hours',
  3: 'three_hours',
  4: 'half_day',
  6: 'six_hours',
  8: 'full_day',
  [-1]: 'multi_day',
};

export type GetCharterTypeUrlType = {
  passengers: number;
  boatId: string;
  tz: string;
  bookingId?: string;
  isBookingMultiDay: boolean;
  selectedPackage: Pick<BoatPackage, 'id' | 'package_type' | 'charter_agreement_type'>;
  tripStart: string;
  tripTime: string;
  duration: string;
  selectedCaptain?: {
    id: string;
    boatOwnerId: string;
  };
};

export const getCharterTypeUrl = ({
  passengers,
  boatId,
  isBookingMultiDay,
  selectedPackage,
  tripStart,
  tripTime,
  duration,
  bookingId,
  tz,
  selectedCaptain,
}: GetCharterTypeUrlType) => {
  const ownerIsCaptain = selectedCaptain?.id && selectedCaptain?.id === selectedCaptain?.boatOwnerId;
  const baseUrl =
    ownerIsCaptain || selectedPackage.charter_agreement_type === 'time_charter'
      ? '/legal/time_charter_party_agreement'
      : '/legal/bareboat_charter_party_agreement';
  const query = queryString.stringify(
    {
      'booking[boat_public_id]': boatId,
      'booking[package_public_id]': selectedPackage?.id,
      'booking[tz]': tz,
      'booking[package_type]': selectedPackage?.package_type,
      'booking[trip_start]': dayjs(tripStart)?.format('MM/DD/YYYY'),
      'booking[is_multi_day]': isBookingMultiDay,
      'booking[duration]': duration?.replace('_cents', ''),
      'booking[trip_time]': tripTime,
      'booking[passengers]': passengers,
    },
    {
      encode: false,
    }
  );

  if (bookingId) return `${baseUrl}?booking_id=${bookingId}`;

  return `${baseUrl}?${query}`;
};

export const createDurationOption = (hours: number, apiName: string) => ({
  value: hours,
  label: `${hours} hours`,
  name: apiName,
  available: true,
});

export const createMultiDayDurationOption = (tripFinish, tripStart) => {
  const dayCount = dayjs(tripFinish).diff(tripStart, 'day') + 1;
  return {
    value: -1,
    available: true,
    name: 'multi_day',
    label: `${dayCount} day${dayCount > 1 ? 's' : ''}`,
  };
};
